import appTheme from '../../common/theme/appTheme.json';

/**
 * TODO: Gus - Refactor button to not use margin-right,
 * will require updating root app styles
 */
export const buttonExportStyle = {
  width: '95px',
  marginRight: '68px',
  borderRadius: '5px',
  fontSize: appTheme.buttonFontSize,
  backgroundColor: appTheme.secondaryBackgroundColor,
  ' &:hover': {
    backgroundColor: appTheme.secondaryBackgroundColor,
  },
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '6px 11px',
  svg: {
    fill: appTheme.secondaryTextColor,
    marginLeft: '6px',
    height: '22px',
  },
};
